import { findServiceUrlsGlobal } from './discoveryService';

export const validateApiKey = async (apiKey) => {
  if (!apiKey || apiKey.trim() === '') {
    return {
      success: false,
      error: 'ApiKey é obrigatória'
    };
  }

  try {
    const discoveryResult = await findServiceUrlsGlobal();

    if (!discoveryResult.success) {
      return {
        success: false,
        error: 'Erro ao buscar configuração dos serviços'
      };
    }

    const apiZwUrl = discoveryResult.serviceUrls?.apiZwUrl;

    if (!apiZwUrl) {
      return {
        success: false,
        error: 'URL do serviço de validação não encontrada'
      };
    }

    const validationUrl = `${apiZwUrl}/psec/credential-validator`;

    const response = await fetch(validationUrl, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Authorization': apiKey.trim()
      }
    });

    if (response.ok) {
      localStorage.setItem('pacto_api_key', apiKey.trim());

      return {
        success: true,
        apiKey: apiKey.trim()
      };
    } else {
      let errorMessage = 'ApiKey inválida ou sem permissão';

      if (response.status === 401) {
        try {
          const htmlText = await response.text();
          const messageMatch = htmlText.match(/<p><b>Message<\/b>\s*([^<]+)<\/p>/);
          if (messageMatch && messageMatch[1]) {
            errorMessage = messageMatch[1].trim();
          } else {
            errorMessage = 'Credencial inválida';
          }
        } catch (e) {
          errorMessage = 'Credencial inválida';
        }
      } else if (response.status === 403) {
        errorMessage = 'ApiKey sem permissão de acesso';
      } else if (response.status === 404) {
        errorMessage = 'Serviço de validação não encontrado';
      } else if (response.status >= 500) {
        errorMessage = 'Erro no servidor. Tente novamente mais tarde';
      }

      return {
        success: false,
        error: errorMessage
      };
    }
  } catch (error) {
    let errorMessage = 'Erro ao validar ApiKey';

    if (error.name === 'TypeError' && error.message.includes('NetworkError')) {
      errorMessage = 'Credencial inválida';
    } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
      errorMessage = 'Erro de conexão com o servidor. Verifique se o serviço está disponível';
    } else if (error.name === 'AbortError') {
      errorMessage = 'Tempo de requisição esgotado. Tente novamente';
    } else if (error.message) {
      errorMessage = `Erro: ${error.message}`;
    }

    return {
      success: false,
      error: errorMessage
    };
  }
};

export const getStoredApiKey = () => {
  return localStorage.getItem('pacto_api_key');
};

export const clearApiKey = () => {
  localStorage.removeItem('pacto_api_key');
};
